import { render, staticRenderFns } from "./QuestionForm.vue?vue&type=template&id=e8d5e7c4"
import script from "./QuestionForm.vue?vue&type=script&lang=js"
export * from "./QuestionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports